module.exports = __webpack_public_path__ + "media/images/weather/202_night-1abb1dc56ecd28331f54b759e7b0c93c.png";